'use client'

import customerService from 'Services/customerService'
import React, { FC, useState } from 'react'
import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'

interface TransferFormData {
  amountMajor: number
}

const TransferToLoan: FC<{ msisdn: string | undefined }> = ({ msisdn }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<TransferFormData>()

  const [loading, setLoading] = useState(false)

  const onSubmit = async (data: TransferFormData) => {
    const confirm = window.confirm('Are you sure you want to transfer this amount?')
    if (!confirm) return

    setLoading(true)
    try {
      await customerService.transferLoanBalance(msisdn, data)

      Swal.fire({
        icon: 'success',
        title: 'Transfer Successful',
        text: 'The amount has been transferred to the loan balance successfully!',
      })

      reset()
    } catch (error: any) {
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: 'Transfer Failed',
        text: error?.response?.data?.error || 'Something went wrong. Please try again.',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <label htmlFor='amountMajor' className='mb-1' style={{ fontSize: '.9rem' }}>
          Amount
        </label>
        <input
          type='number'
          id='amountMajor'
          className={`form-control ${errors.amountMajor ? 'is-invalid' : ''}`}
          placeholder='Enter amount'
          {...register('amountMajor', {
            required: 'Amount is required',
            min: { value: 1, message: 'Amount must be greater than zero' },
          })}
        />
        {errors.amountMajor && <div className='invalid-feedback'>{errors.amountMajor.message}</div>}

        <button type='submit' className='btn btn-default mt-4 w-100' disabled={loading}>
          {loading ? (
            <>
              <span
                className='spinner-border spinner-border-sm me-2'
                role='status'
                aria-hidden='true'
              ></span>
              Processing...
            </>
          ) : (
            'Transfer'
          )}
        </button>
      </form>
    </div>
  )
}

export default TransferToLoan
